import React from "react";
import Map from "./Map.jsx";
import {browserHistory} from "react-router";
import ObjectList from "./ObjectList.jsx";
import MapWithSunstudy from "./MapWithSunstudy";

export default class ObjectMap extends React.Component {
    constructor() {
        super();
        this.state = {
            map: null,
            visibleRooms: [],
            showAll: false
        };

        this.onObjectClick = this.onObjectClick.bind(this);
        this.onAreaClick = this.onAreaClick.bind(this);
        this.onMapResize = this.onMapResize.bind(this);
        this.onAreaMouseEnter = this.onAreaMouseEnter.bind(this);
        this.onAreaMouseLeave = this.onAreaMouseLeave.bind(this);
        this.onObjectMouseEnter = this.onObjectMouseEnter.bind(this);
        this.onObjectMouseLeave = this.onObjectMouseLeave.bind(this);
        this.onRoomFilterChange = this.onRoomFilterChange.bind(this);
        this.onOverviewAreaClick = this.onOverviewAreaClick.bind(this);
        this.onMapResizeReal = this.onMapResizeReal.bind(this);
        this.toggleShowAll = this.toggleShowAll.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        this.loadMap();

    }

    componentDidUpdate(prevProps) {
        let oldId = prevProps.params.id;
        let newId = this.props.params.id;
        if (newId !== oldId) {
            this.loadMap();
        }
    }

    loadMap() {
        const map = this.props.data.object_maps.find(m => {
            return m.id === parseInt(this.props.params.id, 10);
        });

        if (this.props.data.objects) {
            let visibleObjects = [];
            map.regions.map(region => {
                const object = this.props.data.objects.find(obj => {
                    return obj.id === parseInt(region.entity_id, 10);
                });
                region.object = object;
                visibleObjects.push(object);
                return region;
            });

            this.setState({
                visibleObjects: visibleObjects
            });
        }

        const sunstudy = this.props.data.sunstudios ? this.props.data.sunstudios.find(s => {
            return s.map_id === map.id;
        }) : null;


        const availableRooms = this.props.data.objects.map(obj => {
            return obj.rooms;
        }).reduce((p, c) => {
            if (p.indexOf(c) < 0) p.push(c);
            return p;
        }, []).sort();

        this.setState({
            map: map,
            sunstudy: sunstudy,
            visibleRooms: availableRooms
        });
    }

    onAreaClick(area) {
        const object = this.props.data.objects.find(obj => {
            return obj.id === parseInt(area.entity_id, 10);
        });

        if (!object) {
            return false;
        }

        let url = `${this.props.location.pathname}/object/${object.number}`;
        browserHistory.push(url);
    }

    onAreaMouseEnter(area) {
        this.setState({
            hoverObject: area.object
        });
    }

    onAreaMouseLeave(area) {
        this.setState({
            hoverObject: null
        });
    }

    onObjectMouseEnter(object) {
        this.setState({
            hoverObject: object,
        });
    }

    onObjectMouseLeave(object) {
    }

    onObjectClick(object) {
        let url = `${this.props.location.pathname}/object/${object.number}`;
        browserHistory.push(url);
    }

    onMapResize(dimensions) {
        this.setState({
            //mapWidth: dimensions.width,
            mapHeight: dimensions.height,
        });
    }

    toggleShowAll() {
        this.setState({
            showAll: !this.state.showAll
        });
    }

    onMapResizeReal(dimensions) {
        this.setState({
            //mapWidth: dimensions.width,
            mapHeight: dimensions.height,
        });
    }

    goBack() {
        browserHistory.push(`/${this.props.params.widget}`);
    }

    onRoomFilterChange(rooms) {
        this.setState({
            visibleRooms: rooms
        });
    }

    onOverviewAreaClick(area) {
        browserHistory.push(`/${this.props.params.widget}/map/${area.map_id}`);
    }

    render() {
        if (!this.state.map) {
            return null;
        }

        const idx = this.props.data.object_maps.findIndex(m => {
            return m.id === this.state.map.id;
        });

        const nextMap = this.props.data.object_maps[idx + 1] ? this.props.data.object_maps[idx + 1] : null;
        const previousMap = this.props.data.object_maps[idx - 1] ? this.props.data.object_maps[idx - 1] : null;
        const backButton = !!this.props.data['template_data']['overview'];

        let map;

        if (this.state.sunstudy) {
            map = <MapWithSunstudy map={this.state.map}
                                   showAll={this.state.showAll}
                                   objects={this.props.data.objects}
                                   visibleRooms={this.state.visibleRooms}
                                   sunstudy={this.state.sunstudy}
                                   onResize={this.onMapResize}
                                   onMapResize={this.onMapResizeReal}
                                   onAreaClick={this.onAreaClick}
                                   nextMap={nextMap}
                                   previousMap={previousMap}
                                   hoverObject={this.state.hoverObject}
                                   onRoomFilterChange={this.onRoomFilterChange}
                                   onAreaMouseEnter={this.onAreaMouseEnter}
                                   onAreaMouseLeave={this.onAreaMouseLeave}>

                <button type="button" onClick={this.toggleShowAll}
                        className={this.state.showAll ? 'cw-map-toggle-all active' : 'cw-map-toggle-all'}>
                    Visa alla
                </button>

                {backButton ?
                    <button type="button" onClick={this.goBack} className={'cw-map-back'}>
                        Översiktsbild</button> : ''
                }
            </MapWithSunstudy>
        } else {
            map = <Map map={this.state.map}
                       showAll={this.state.showAll}
                       objects={this.props.data.objects}
                       visibleRooms={this.state.visibleRooms}
                       onResize={this.onMapResize}
                       onMapResize={this.onMapResizeReal}
                       onAreaClick={this.onAreaClick}
                       nextMap={nextMap}
                       previousMap={previousMap}
                       templateData={this.props.data.template_data}
                       hoverObject={this.state.hoverObject}
                       onRoomFilterChange={this.onRoomFilterChange}
                       onAreaMouseEnter={this.onAreaMouseEnter}
                       onAreaMouseLeave={this.onAreaMouseLeave}>

                <button type="button" onClick={this.toggleShowAll}
                        className={this.state.showAll ? 'cw-map-toggle-all active' : 'cw-map-toggle-all'}>
                    Visa alla
                </button>

                {backButton ?
                    <button type="button" onClick={this.goBack} className={'cw-map-back'}>
                        Översiktsbild</button> : ''
                }
            </Map>
        }

        return (
            <div>
                <div className="cw-object-map-wrap">

                    <div className="cw-map">
                        {map}
                    </div>
                    <ObjectList objects={this.state.visibleObjects}
                                width={this.state.mapWidth}
                                height={this.state.mapHeight}
                                templateData={this.props.data.template_data}
                                hoverObject={this.state.hoverObject}
                                visibleRooms={this.state.visibleRooms}
                                onObjectMouseEnter={this.onObjectMouseEnter}
                                onObjectMouseLeave={this.onObjectMouseLeave}
                                onObjectClick={this.onObjectClick}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ObjectMap.jsx